import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ICellRendererAngularComp, ITooltipAngularComp } from "ag-grid-angular";
import { ITooltipParams } from "ag-grid-community";

@Component({
  selector: 'tooltip-cell',
  templateUrl: './tooltip-renderer.component.html',
  styleUrls: ['./tooltip-renderer.component.scss'],
  standalone: true,
  imports: [TranslateModule, CommonModule]
})
export class TooltipRenderComponent implements ITooltipAngularComp {
  public params: any;
  isTooltipDisplay: boolean;
  tooltipText: string;
  constructor() {
    //https://www.ag-grid.com/angular-grid/component-tooltip/
  }

  initilize(params: any) {
    if (params && params.data) {
      this.params = params;
      this.isTooltipDisplay = params.data.isTooltipDisplay;
      this.tooltipText = params.data.tooltipText;
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
